/**
 * @generated SignedSource<<81505a7fd5b4101b9f83c5a8c318a9eb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerPatient_WaitingRoomAppointment$data = {
  readonly appointment: {
    readonly patient: {
      readonly __typename: string;
      readonly emailAddress: string | null;
      readonly id: string;
      readonly phoneNumber: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PatientFragment" | "appointmentDrawerHeader_patient">;
    };
  };
  readonly " $fragmentType": "appointmentDrawerPatient_WaitingRoomAppointment";
};
export type appointmentDrawerPatient_WaitingRoomAppointment$key = {
  readonly " $data"?: appointmentDrawerPatient_WaitingRoomAppointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerPatient_WaitingRoomAppointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerPatient_WaitingRoomAppointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "emailAddress",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PatientFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "appointmentDrawerHeader_patient"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};

(node as any).hash = "d9bcaeecc91eaabc26e2b7d66702d570";

export default node;
